import { LISTING_TYPES } from "../../../../Offerings/constants/Offering.constants";

export const LISTING_TYPE_BASED_PROPS = {
  [LISTING_TYPES.APPOINTMENTS]: {
    TITLE: "Appointment",
    COLOR: "#FF5D8F",
    BORDER_COLOR: "#FF5D8F80",
  },
  [LISTING_TYPES.WORKSHOPS]: {
    TITLE: "Workshop",
    COLOR: "#46A58A",
    BORDER_COLOR: "#46A58A80",
  },
  [LISTING_TYPES.GROUP_CLASSES]: {
    TITLE: "Class",
    COLOR: "#0096C7",
    BORDER_COLOR: "#0096C780",
  },
  [LISTING_TYPES.ONE_ON_ONE_CLASSES]: {
    TITLE: "Class",
    COLOR: "#0096C7",
    BORDER_COLOR: "#0096C780",
  },
  [LISTING_TYPES.ROLLING_CLASSES]: {
    TITLE: "Class",
    COLOR: "#0096C7",
    BORDER_COLOR: "#0096C780",
  },
  [LISTING_TYPES.WEBINAR]: {
    TITLE: "Webinar",
    COLOR: "#F3722C",
    BORDER_COLOR: "#F9844A80",
  },
};
